import { combineReducers } from '@reduxjs/toolkit';

import alternativeHotels from './alternativeHotels';
import appStatus from './appStatus';
import combinationInfo from './combinationInfo';
import common from '../common';
import error from './error';
import hotelData from './hotelData';
import labels from './labels';
import message from './message';
import searchInformation from './searchInformation';
import transportData from './transportData';

// `common` is seeded through `preloadedState`.
const priceMatrixApp = combineReducers({
  alternativeHotels,
  appStatus,
  combinationInfo,
  common,
  error,
  hotelData,
  labels,
  message,
  searchInformation,
  transportData,
});

export default priceMatrixApp;
